import React, { useState, useEffect } from 'react';
import api from '../services/api';

const LEEG = { naam: '', email: '', telefoon: '', contactpersoon: '', adres: '', postcode: '', plaats: '', kvk_nummer: '', btw_nummer: '', iban: '', opmerking: '' };

export default function OnderaannemersBeheer() {
  const [lijst, setLijst] = useState([]);
  const [form, setForm] = useState(LEEG);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [busy, setBusy] = useState(false);

  const laad = async () => {
    try { const r = await api.get('/onderaannemers'); setLijst(r.data.onderaannemers || []); } catch (e) {}
  };
  useEffect(() => { laad(); }, []);

  const opslaan = async () => {
    if (!form.naam || !form.email) { alert('Naam en e-mail zijn verplicht'); return; }
    setBusy(true);
    try {
      if (editId) await api.put(`/onderaannemers/${editId}`, form);
      else await api.post('/onderaannemers', form);
      setForm(LEEG); setEditId(null); setShowForm(false); laad();
    } catch (e) { alert(e.response?.data?.message || 'Fout bij opslaan'); }
    setBusy(false);
  };

  const bewerk = (o) => {
    setEditId(o.id);
    setForm({ naam: o.naam || '', email: o.email || '', telefoon: o.telefoon || '', contactpersoon: o.contactpersoon || '', adres: o.adres || '', postcode: o.postcode || '', plaats: o.plaats || '', kvk_nummer: o.kvk_nummer || '', btw_nummer: o.btw_nummer || '', iban: o.iban || '', opmerking: o.opmerking || '' });
    setShowForm(true);
  };

  const deactiveer = async (o) => {
    if (!window.confirm(o.naam + ' deactiveren? (verdwijnt uit keuzelijsten)')) return;
    try { await api.put(`/onderaannemers/${o.id}`, { actief: false }); laad(); } catch (e) { alert('Fout'); }
  };

  const veld = (key, label, breed) => (
    <div style={{ gridColumn: breed ? '1 / -1' : 'auto' }}>
      <div style={{ fontSize: '12px', fontWeight: 600, color: '#6b7280', marginBottom: '4px' }}>{label}</div>
      <input value={form[key]} onChange={e => setForm({ ...form, [key]: e.target.value })}
        style={{ width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #d1d5db', boxSizing: 'border-box', fontSize: '14px' }} />
    </div>
  );

  return (
    <div style={{ padding: '24px', maxWidth: '1000px', margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ margin: 0 }}>🏗️ Onderaannemers</h1>
        <button onClick={() => { setForm(LEEG); setEditId(null); setShowForm(true); }}
          style={{ background: '#00D4AA', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 16px', fontWeight: 600, cursor: 'pointer' }}>+ Onderaannemer</button>
      </div>

      {showForm && (
        <div style={{ background: '#fff', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <h3 style={{ marginTop: 0 }}>{editId ? '✏️ Bewerken' : '➕ Nieuwe onderaannemer'}</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            {veld('naam', 'Bedrijfsnaam *')}
            {veld('email', 'E-mail * (ontvangt opdrachtvoorstellen)')}
            {veld('contactpersoon', 'Contactpersoon')}
            {veld('telefoon', 'Telefoon')}
            {veld('adres', 'Adres', true)}
            {veld('postcode', 'Postcode')}
            {veld('plaats', 'Plaats')}
            {veld('kvk_nummer', 'KvK-nummer')}
            {veld('btw_nummer', 'BTW-nummer')}
            {veld('iban', 'IBAN', true)}
            {veld('opmerking', 'Opmerking', true)}
          </div>
          <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
            <button onClick={opslaan} disabled={busy} style={{ background: '#00D4AA', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 18px', fontWeight: 600, cursor: 'pointer' }}>{busy ? 'Bezig…' : '💾 Opslaan'}</button>
            <button onClick={() => { setShowForm(false); setEditId(null); }} style={{ background: '#f3f4f6', border: 'none', borderRadius: '8px', padding: '10px 18px', cursor: 'pointer' }}>Annuleren</button>
          </div>
        </div>
      )}

      <div style={{ background: '#fff', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
        {lijst.length === 0 && <div style={{ padding: '24px', color: '#6b7280' }}>Nog geen onderaannemers.</div>}
        {lijst.map(o => (
          <div key={o.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', borderBottom: '1px solid #f3f4f6' }}>
            <div>
              <div style={{ fontWeight: 600 }}>{o.naam} {!o.planning_gebruiker_id && <span title="Geen planning-rij" style={{ fontSize: '12px', color: '#d97706' }}>⚠️</span>}</div>
              <div style={{ fontSize: '13px', color: '#6b7280' }}>
                {o.email}{o.contactpersoon ? ' · ' + o.contactpersoon : ''}{o.telefoon ? ' · ' + o.telefoon : ''}{o.plaats ? ' · ' + o.plaats : ''}{o.kvk_nummer ? ' · KvK ' + o.kvk_nummer : ''}
              </div>
            </div>
            <div style={{ display: 'flex', gap: '6px' }}>
              <button onClick={() => bewerk(o)} style={{ background: '#f3f4f6', border: 'none', borderRadius: '6px', padding: '6px 12px', fontSize: '13px', cursor: 'pointer' }}>✏️</button>
              <button onClick={() => deactiveer(o)} style={{ background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: '6px', padding: '6px 12px', fontSize: '13px', cursor: 'pointer' }}>🗑️</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
